import InputButton from 'Components/UI/Organisms/Plant/Stock/PaperDevolution/DialogDevolution/InputButton'
import { ESTADO, FORMATO_VENTA, SUCURSAL_ORIGEN } from 'Constants'

export const Step1 = (info, handleSubmitCode, handleChange, isLoading, data) => {
  const tipoResponsable = data.tipo_responsable.find(
    (item) => item.value === info.tipo_responsable
  )?.name

  const formatoVentaLabel = FORMATO_VENTA.find((f) => f.id === Number(info.formato_venta))?.label

  return [
    {
      label: 'Origen',
      name: 'empresa',
      options: SUCURSAL_ORIGEN,
      optionLabel: `options["label"]`,
      optionValue: 'id',
      sm: 12,
      xs: 12,
      class: 'autocomplete',
      value: info.empresa,
      onChange: (e) => handleChange('empresa', e.id),
    },
    {
      label: 'Formato de venta',
      name: 'formato_venta',
      options: FORMATO_VENTA,
      optionLabel: `options["label"]`,
      optionValue: 'label',
      sm: 12,
      xs: 12,
      class: 'autocomplete',
      value: formatoVentaLabel,
      onChange: (e) => handleChange('formato_venta', e.id),
    },
    {
      class: 'custom', //ob
      name: 'search',
      component: (
        <InputButton
          placeholder="CUIT/CUIL/DNI O NOMBRE"
          name="search"
          onSubmit={() => handleSubmitCode(info)}
          onKeyUp={(e) => handleChange('search', e.target.value)}
          value={info.search}
          resetFormDisabled
          loading={isLoading}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      label: 'Tipo responsable',
      name: 'tipo_responsable',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: tipoResponsable,
    },
    {
      label: 'DNI/CUIT/CUIL',
      name: 'cuit',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: info.cuit,
    },
    {
      label: 'Razón social',
      name: 'nombre',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: info.nombre,
    },
    {
      label: 'Estado',
      name: 'estado',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: info.estado != null ? ESTADO.find((e) => e.value === Number(info.estado))?.label : '',
    },
  ]
}

export const CtaClient = (info, handleSubmitCode, handleChange, isLoading, data) => {
  const tipoResponsable = data.tipo_responsable.find(
    (item) => item.value === info.tipo_responsable
  )?.name

  return [
    {
      label: 'Origen',
      name: 'empresa',
      // options: SUCURSAL_ORIGEN,
      // optionLabel: `options["label"]`,
      // optionValue: "id",
      disabled: true,
      sm: 12,
      xs: 12,
      class: 'textfield',
      value: info.empresa,
    },
    {
      label: 'Formato de venta',
      name: 'formato_venta',
      // options: FORMATO_VENTA,
      // optionLabel: `options["label"]`,
      // optionValue: "label",
      disabled: true,
      sm: 12,
      xs: 12,
      class: 'textfield',
      value: info.formato_venta,
      //onChange: (e) => handleChange("formato_venta", e.id)
    },
    {
      class: 'custom', //ob
      name: 'search',
      component: (
        <InputButton
          placeholder="CUIT/CUIL/DNI O NOMBRE"
          name="search"
          onSubmit={() => handleSubmitCode(info)}
          onKeyUp={(e) => handleChange('search', e.target.value)}
          value={info.search}
          resetFormDisabled
          loading={isLoading}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      label: 'Tipo responsable',
      name: 'tipo_responsable',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: tipoResponsable,
    },
    {
      label: 'DNI/CUIT/CUIL',
      name: 'cuit',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: info.cuit,
    },
    {
      label: 'Razón social',
      name: 'nombre',
      sm: 12,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: info.nombre,
    },
  ]
}
